export const translation = {
  hotel: {
    'Distance to lift': 'Hissille',
    'Distance to town centre': 'Keskustaan',
    'Distance to skibus': 'Hiihtobussille',

    'Customer rating': 'Kundbetyg',
    'Book now': 'Varaa nyt',
    'Show photos': 'Kaikki kuvat',
    'Rooms at ': 'Huoneet hotellissa ',
    'Guest reviews': 'Vieraiden arvostelut',
    'Guest review description':
      'Lainaukset on otettu kyselylomakkeista, jotka matkustajamme täyttävät matkan jälkeen. Olemme ylpeitä siitä, että monet vieraamme palaavat vuosi toisensa jälkeen. Viime talvikauden (2024) jälkeen yli 93 % vieraistamme vastasi, että he haluavat matkustaa kanssamme uudelleen. ',
    'Hotel facilities': 'Hotellin tiedot',
    Yes: 'Kyllä',
    'Show all': 'Näytä enemmän',
    'Show less': 'Näytä vähemmän',
    'Tripadvisor title': 'Huippu arvosanat Tripadvisorissa',
    'Tripadvisor description':
      '{{rating}}/5 tähteä perustuen {{numberOfRatings}} arvosteluun',
    'Tripadvisor link': 'Lue lisää Tripadvisorista',
    AUT: 'Itävalta',
    ITA: 'Italia',
    FRA: 'Ranska',
    'Title template': 'Varaa {{hotel}} {{destination}}, {{country}}',
  },
  booking: {
    StartingPrice: 'Varaa alk. {{price}} €/hlö',
    PerPersonPrice: 'Varaa alk. {{price}} €/hlö.',
    PerPersonPriceCurrency: '{{price}} €/hlö.',
    FamilyPrice: 'Perhehinta alk. {{price}} €',
    TotalPrice: 'Kokonaishinta alk. {{price}} €',
    FlightPrice: 'Vain lento alk. {{price}} €',
    Currency: '€',
    Savings: 'Säästä {{price}} €',
    'All destinations': 'Kaikki kohteet',

    'Could not find any proposals':
      'Valitettavasti etsimällesi ajankohdalle ei löydy vapaita matkoja {{date}}.',
    'No proposals found':
      'Haullasi ei löytynyt matkoja. Kokeile toista päivämäärää tai kohdetta.',
    'Show period': 'Näytä seuraava vapaa ajankohta {{date}}',
    PackagePrice: 'Varaa All Inclusive alk. {{price}}€/henkilö',

    'Book now': 'Varaa nyt',
    'Send request': 'Lähetä kysely',
    'Coming soon': 'Tulossa pian',
    Traveltype: 'Matkatyypit',
    From: 'Mistä',
    To: 'Kohde',
    Traveldate: 'Päivä',
    Travelers: 'Matkustajat',

    Search: 'Etsi matka',
    'Book trip': 'Varaa matka',
    'Week short': 'Vko.',

    Room: 'Huone',
    Rooms: 'Huone',

    room: 'huone',
    rooms: 'huone',

    adult: 'Aikuista',
    Adults: 'Aikuista',
    adults: 'aikuista',
    'No adults': 'Ei aikuisia',
    'Children Ages': 'Lapset/nuoret (0-17 v):',
    Child: 'Lapset',
    child: 'lapset',
    Children: 'Lasta',
    children: 'lasta',
    'No children': 'Ei lapsia',
    'Age children': 'Lasten/nuorten iät (paluulennon ajankohtana)',
    'Discount code': 'Rabattkod:',
    'Child nr': 'Lapsi {{nr}}',
    'Rooms and travelers': 'Huoneet ja matkailijat',
    years: 'vuotta',
    MonthShort: {
      1: 'tam',
      2: 'hel',
      3: 'maa',
      4: 'huh',
      5: 'tou',
      6: 'kes',
      7: 'hei',
      8: 'elo',
      9: 'syy',
      10: 'lok',
      11: 'mar',
      12: 'jou',
    },
    Charter: 'Pakettimatka',
    Hotel: 'Vain hotelli',
    Flight: 'Vain lento',
    'Find trip': 'Etsi matka',
    'Add room': 'Lisää huoneita',
    'Remove room': 'Poista huone',
    Close: 'Sulje',

    charterTypes: {
      Winter: 'Hiihtomatkat',
      Summer: 'Kesämatkat',
      Christmas: 'Pikkujoulumatkat',
      Hiking: 'Vaellusmatkat',
    },
    priceReference:
      'Koskee matkaa {{airport}} lentokentältä {{travelDateFrom}} {{hotelName}} {{roomDescription}}',
    priceReferenceWithoutHotel:
      'Koskee matkaa {{airport}} lentokentältä {{travelDateFrom}} {{roomDescription}}',
    'Find price and book': 'Katso hinta',
    'More than 9 travelers?': 'Yli 9 matkustajaa? Klikkaa tästä',
  },
  labels: {
    'city-center': 'Keskustaan',
    'city-centre-value': '{{value}} m',
    'ski-bus': 'Hiihtobussille',
    'ski-bus-value': '{{value}} m',
    'ski-lift': 'Hissille',
    'ski-lift-value': '{{value}} m',
    'black-runs': 'Mustia rinteitä',
    'black-runs-value': '{{value}} kpl',
    'red-runs': 'Punaisia rinteitä',
    'red-runs-value': '{{value}} kpl',
    'blue-runs': 'Sinisiä rinteitä',
    'blue-runs-value': '{{value}} kpl',
    peak: 'Korkein hiihtoalue',
    'peak-value': '{{value}} m',
    valley: 'Kyläkorkeus',
    'valley-value': '{{value}} m',
    vertical: 'Suurin korkeusero',
    'vertical-value': '{{value}} m',
    'piste-length': 'Rinteitä',
    'piste-length-value': '{{value}} km',
    'ski-lifts': 'Hissejä',
    'ski-lifts-value': '{{value}} kpl',
    'transfer-time': 'Kuljetus',
    'transfer-time-value': '{{value}}',
    'cross-country-trails': 'Murtomaahiihtoladut',
    'cross-country-trails-value': '{{value}} km',
    restaurants: 'Restauranger',
    'restaurants-value': '{{value}}',
    'mountain-restaurants': 'Bergsrestauranger',
    'mountain-restaurants-value': '{{value}}',
    'after-ski-bars': 'Afterski-ställen',
    'after-ski-bars-value': '{{value}}',
    bars: 'Barer',
    'bars-value': '{{value}}',
    monday: 'Maanantai',
    tuesday: 'Tiistai',
    wednesday: 'Keskiviikko',
    thursday: 'Torstai',
    friday: 'Perjantai',
    saturday: 'Lauantai',
    sunday: 'Sunnuntai',
    closed: 'Suljettu',
  },
  footer: {
    'Select country': 'Valitse maa',
    News: 'Uutuus!',
    'E-mail address': 'Sähköpostiosoite',
    Subscribe: 'Tilaa',
  },
  header: {
    'Open hours today': 'Avoinna tänään klo',
    Menu: 'Menu',
    Start: 'Alku',
  },
  error: {
    'Page not found': 'Sivua ei löytynyt',
    'Page not found description':
      'Yritä löytää sivu ylävalikosta tai kirjoita linkki uudelleen.',
  },
  charts: {
    variable: 'Verrata',
    destination: 'Kohde',
    avg_snowfall: 'Lumisade',
    snowfall_days: 'Lumisade päivät',
    avg_snow_depth: 'Lumensyvyys',
    biggest_snowfall: 'Suurin lumisade',
    all: 'Kaikki',
    December: 'Joulukuu',
    Januari: 'Tammikuu',
    Februari: 'Helmikuu',
    Mars: 'Maaliskuu',
    April: 'Huhtikuu',
  },
  countdown: {
    DAYS: 'Päivää',
    HOURS: 'Tuntia',
    MINUTES: 'Minuuttia',
    SECONDS: 'Sekuntia',
  },
  profile: {
    hero: {
      greeting: 'Hei {0}',
      header: 'Matkani',
      message: 'Hei {0}, tervetuloa tarkastelemaan matkaasi',
      afterTripMessage:
        'Kiitos {0}, että matkustit kanssamme. Tervetuloa uudestaan!',
      daysLeft: 'lähtöön aikaa',
      title: 'Matkustat kohteeseen {0}',
    },
    flight: {
      header: 'Matkan tiedot',
      travelTime: 'Matka-aika',
      addSki: 'Lisää suksirahti',
      luggage: 'Hintaan sisältyy {0} ruumamatkatavara henkilöä kohden {1}',
      skiLuggage: '1 pari suksia + sauvoja, 1 pari monoja, 1 kypärä - max {0}',
    },
    summary: {
      header: 'Yhteenveto',
      header2: 'Maksuja',
      isPaid: 'Matkasi on maksettu',
      isCancelled: 'Matkasi on peruutettu',
      bookingNumber: 'Varausnumero',
      bookingDate: 'Varauspäivämäärä',
      bookingPerson: 'Varaaja',
      bookingPrice: 'Kokonaishinta',
      bookingFee: 'Varausmaksu',
      bookingFeeHelp: 'Viimeksi maksettu {0}',
      bookingPayment: 'Loppumaksu',
      bookingPaymentHelp: 'Viimeksi maksettu {0}',
      hint1: 'Kun matka on kokonaan maksettu voit ladata matkalippusi tästä',
      hint2:
        'Seuraavassa vaiheessa valitset mikäli maksat varausmaksun tai koko matkat hinnan',
      email: 'Sähköposti',
      phoneNumber: 'Puhelin',
      paid: 'Maksettu',
      leftToPay: 'Maksettavaa jäljellä',
    },
    tabs: {
      booking: 'Varaus',
      faq: 'FAQ',
      addons: 'Lisäpalvelut',
    },
    travellers: {
      header: 'Matkustajat',
      name: 'Nimi',
      room: 'Huone',
      type: 'Tyyppi',
      typeAdult: 'Aikuinen',
      typeChild: 'Lapsi',
      dateOfBirth: 'Syntymäpäivä',
      gender: 'Sukupuoli',
      genderMale: 'Mies',
      genderFemale: 'Nainen',
      notice:
        'Haluatko lisätä matkustajia? Ota yhteyttä info@alppimatkat.fi tai soita <span>09-67 13 14</span>',
    },
    destination: {
      header: 'Kohde ja hotelli',
      destination: 'Matkakohde',
      hotel: 'Hotelli',
      checkIn: 'Sisäänkirjautuminen',
      checkOut: 'Uloskirjautuminen',
      package: 'Paketti',
      linkLabel: 'Huone ja matkustaja',
      linkText: 'Katso alempana',
    },
    includes: {
      header: 'Minun valintani',
      seeAll: 'Katso muut lisävalinnat',
      edit: 'Muokkaa',
      included: 'Sisältää',
      skiSchool: 'Hiihtokoulu',
      excursion: 'Retket',
      skiRental: 'Suksivuokra',
      skiPass: 'Hissilippu',
      flightMeal: 'Lentokoneruokailu',
      skiLuggage: 'Suksikuljetus',
      transfer: 'Lentokenttäkuljetus',
      travelInsurance: 'Matkavakuutus',
      hiking: 'Vaellus',
      travelers: '{0} kpl',
      pricing: '{0}/kpl',
    },
    addons: {
      deadline: 'Varaa viimeistään {0}',
      order: 'Lisää',
      durationDays: '{0} päivää',
      durationDay: '{0} päivä',
      addonSkiCategory: 'Sukset',
      addonFlightCategory: 'Lento & matka',
      addonHikingCategory: 'Vaellus',
      addonExcursionCategory: 'Muut aktiviteetit',
      addonNoneCategory: 'Muut',
    },
    cta: {
      depositLeftText: 'Varmista matkasi - Maksa {0} nyt',
      notPayedText: 'Maksa matkasi loppumaksu',
      allPayedText: 'Matkasi on maksettu',
      logout: 'Kirjaudu ulos',
    },
    activities: {
      heading: 'Viikon aktiviteetit',
      description:
        'Me STS Alppimatkoilla järjestämme paljon retkiä ja aktiviteettejä oppaidemme ja asiakkaidemme kanssa, jonne voit osallistua matkan aikana.',
    },
    bookingConfirmation: {
      isPaid: 'Lataa matkalippu',
      notPaid: 'Lataa varausvahvistus',
    },
    login: {
      form: {
        bookingRefLabel: 'Varausnumero',
        bookingRefPlaceholder: '00000000',
        emailLabel: 'E-mail',
        emailPlaceholder: 'sinä@esimerkki.fi',
        submitLabel: 'Login',
        errorMessage:
          'Jokin meni väärin, tarkistathan tietosi ja kokeile uudestaan',
      },
    },
  },
};
